export const JIRA_PRODUCT_DISCOVERY_PRODUCT_KEY = 'jira-product-discovery';
